<template>
  <div id="app">
    <div class="topmeun" v-if="!isMobile">
      <div class="meun">
        <div class="meun_left">
          <img src="./assets/logotop.png" alt />
        </div>
        <div class="meun_right">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item index="1" @click="$router.push('/')">
              网站首页
            </el-menu-item>
            <el-submenu index="2">
              <template slot="title">著作展示</template>
              <el-menu-item index="2-1" @click="goroute(1)">
                医学影像数字化技术（Ⅰ）
              </el-menu-item>
              <el-menu-item index="2-2" @click="goroute(2)">
                医院信息化技术（Ⅱ）
              </el-menu-item>
              <el-menu-item index="2-3" @click="goroute(3)">
                医院信息化技术（Ⅲ）
              </el-menu-item>
              <el-menu-item index="2-4" @click="goroute(4)">
                医院信息化技术（Ⅳ）
              </el-menu-item>
            </el-submenu>
            <el-menu-item index="3" @click="$router.push('/chanpin')">
              产品信息
            </el-menu-item>
            <el-menu-item index="4" @click="$router.push('/newmeet')">
              新闻中心
            </el-menu-item>
            <el-submenu index="5">
              <template slot="title">关于我们</template>
              <el-menu-item index="5-1" @click="titlego(1)">
                公司介绍
              </el-menu-item>
              <el-menu-item index="5-2" @click="titlego(2)">
                企业资质
              </el-menu-item>
              <el-menu-item index="5-3" @click="titlego(3)">
                技术支持
              </el-menu-item>
            </el-submenu>
            <el-submenu index="6">
              <template slot="title">典型案例</template>
              <el-menu-item index="6-1" @click="anligo(1)">
                广东省越秀区农林街养老项目
              </el-menu-item>
              <el-menu-item index="6-2" @click="anligo(2)">
                广东省越秀区建设街养老项目
              </el-menu-item>
              <el-menu-item index="6-3" @click="anligo(3)">
                广东省荔湾区西村街养老项目
              </el-menu-item>
              <el-menu-item index="6-4" @click="anligo(4)">
                广弘投资智能化智慧型医疗健康养老项目
              </el-menu-item>
              <el-menu-item index="6-5" @click="anligo(5)">
                新疆阿勒泰地区青河县乡一体化分级诊疗平台
              </el-menu-item>
              <el-menu-item index="6-6" @click="anligo(6)">
                从都国际生命健康管理中心
              </el-menu-item>
              <el-menu-item index="6-7" @click="anligo(7)">
                河南省郑州大学第一附属医院
              </el-menu-item>
              <el-menu-item index="6-8" @click="anligo(8)">
                西安交大医学院第一附属医院
              </el-menu-item>
              <el-menu-item index="6-9" @click="anligo(9)">
                中国人民解放军总医院（301）
              </el-menu-item>
              <el-menu-item index="6-10" @click="anligo(10)">
                大连大学附属中山医院
              </el-menu-item>
              <el-menu-item index="6-11" @click="anligo(11)">
                哈尔滨医科大学第四附属医院
              </el-menu-item>
              <el-menu-item index="6-12" @click="anligo(12)">
                北京大学深圳医院
              </el-menu-item>
              <el-menu-item index="6-13" @click="anligo(13)">
                首都医科大学附属北京胸科医院
              </el-menu-item>
              <el-menu-item index="6-14" @click="anligo(14)">
                首都医科大学附属北京佑安医院
              </el-menu-item>
              <el-menu-item index="6-15" @click="anligo(15)">
                上海市（复旦大学附属）公共卫生临床中心
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </div>
    </div>
    <div class="topme" v-if="isMobile">
      <div class="topm">
        <div class="meun_left">
          <img src="./assets/logotop.png" alt />
        </div>
        <div class="meun_right">
          <span v-show="!visb">
            <i class="el-icon-s-unfold" @click="visb = true"></i>
          </span>
          <span v-show="visb">
            <i class="el-icon-close" @click="visb = false"></i>
          </span>
        </div>
      </div>
      <transition name="el-zoom-in-top">
        <div class="topf" v-show="visb">
          <div class="shoume">
            <el-menu
              :default-active="activeIndex"
              class="el-menu-demo"
              @select="handleSelect"
            >
              <el-menu-item index="1" @click="$router.push('/')">
                <span slot="title">网站首页</span>
              </el-menu-item>
              <el-submenu index="2">
                <template slot="title">著作展示</template>
                <el-menu-item index="2-1" @click="goroute(1)">
                  医学影像数字化技术（Ⅰ）
                </el-menu-item>
                <el-menu-item index="2-2" @click="goroute(2)">
                  医院信息化技术（Ⅱ）
                </el-menu-item>
                <el-menu-item index="2-3" @click="goroute(3)">
                  医院信息化技术（Ⅲ）
                </el-menu-item>
                <el-menu-item index="2-4" @click="goroute(4)">
                  医院信息化技术（Ⅳ）
                </el-menu-item>
              </el-submenu>
              <el-menu-item index="3" @click="$router.push('/chanpin')">
                产品信息
              </el-menu-item>
              <el-menu-item index="4" @click="$router.push('/newmeet')">
                新闻中心
              </el-menu-item>
              <el-submenu index="5">
                <template slot="title">关于我们</template>
                <el-menu-item index="5-1" @click="titlego(1)">
                  公司介绍
                </el-menu-item>
                <el-menu-item index="5-2" @click="titlego(2)">
                  企业资质
                </el-menu-item>
                <el-menu-item index="5-3" @click="titlego(3)">
                  技术支持
                </el-menu-item>
              </el-submenu>
              <el-submenu index="6">
                <template slot="title">典型案例</template>
                <el-menu-item index="6-1" @click="anligo(1)">
                  广东省越秀区农林街养老项目
                </el-menu-item>
                <el-menu-item index="6-2" @click="anligo(2)">
                  广东省越秀区建设街养老项目
                </el-menu-item>
                <el-menu-item index="6-3" @click="anligo(3)">
                  广东省荔湾区西村街养老项目
                </el-menu-item>
                <el-menu-item index="6-4" @click="anligo(4)">
                  广弘投资智能化智慧型医疗健康养老项目
                </el-menu-item>
                <el-menu-item index="6-5" @click="anligo(5)">
                  新疆阿勒泰地区青河县乡一体化分级诊疗平台
                </el-menu-item>
                <el-menu-item index="6-6" @click="anligo(6)">
                  从都国际生命健康管理中心
                </el-menu-item>
                <el-menu-item index="6-7" @click="anligo(7)">
                  河南省郑州大学第一附属医院
                </el-menu-item>
                <el-menu-item index="6-8" @click="anligo(8)">
                  西安交大医学院第一附属医院
                </el-menu-item>
                <el-menu-item index="6-9" @click="anligo(9)">
                  中国人民解放军总医院（301）
                </el-menu-item>
                <el-menu-item index="6-10" @click="anligo(10)">
                  大连大学附属中山医院
                </el-menu-item>
                <el-menu-item index="6-11" @click="anligo(11)">
                  哈尔滨医科大学第四附属医院
                </el-menu-item>
                <el-menu-item index="6-12" @click="anligo(12)">
                  北京大学深圳医院
                </el-menu-item>
                <el-menu-item index="6-13" @click="anligo(13)">
                  首都医科大学附属北京胸科医院
                </el-menu-item>
                <el-menu-item index="6-14" @click="anligo(14)">
                  首都医科大学附属北京佑安医院
                </el-menu-item>
                <el-menu-item index="6-15" @click="anligo(15)">
                  上海市（复旦大学附属）公共卫生临床中心
                </el-menu-item>
              </el-submenu>
            </el-menu>
          </div>
        </div>
      </transition>
    </div>
    <router-view />
    <div class="flootli" v-if="!isMobile">
      <div class="flootmon">
        <div class="flex1">
          <div class="tit">著作展示</div>
          <div class="titli" @click="goroute(1)">医学影像数字化技术（Ⅰ）</div>
          <div class="titli" @click="goroute(2)">医院信息化技术（Ⅱ）</div>
          <div class="titli" @click="goroute(3)">医院信息化技术（Ⅲ）</div>
          <div class="titli" @click="goroute(4)">医院信息化技术（Ⅳ）</div>
        </div>
        <div class="flex2">
          <div class="tit">北京洛克斯科技发展有限公司</div>
          <div class="titli">
            <p>
              地址：中国·北京·中关村医学工程转化中心1号楼四层<br />
              电 话：010-81787502<br />邮 箱：locus@chinalocus.com<br />邮编：100094
            </p>
          </div>
          <div class="titli">
            <el-tooltip placement="top" effect="light">
              <div slot="content">
                <img src="./assets/wx.jpg" alt />
              </div>
              <img class="imwx" src="./assets/300.jpg" alt />
            </el-tooltip>
          </div>
        </div>
        <div class="flex1">
          <div class="tit">关于我们</div>
          <div class="titli" @click="titlego(1)">公司介绍</div>
          <div class="titli" @click="titlego(2)">企业资质</div>
          <div class="titli" @click="titlego(3)">技术支持</div>
        </div>
      </div>
      <div class="titli toplis">
        Copyright©2019 北京洛克斯科技发展有限公司&nbsp;
        <span class="icp" @click="goicp">京ICP备08008930号-1</span>
      </div>
    </div>
    <div class="flootlis" v-if="isMobile">
      <div class="flootmon">
        <div class="flex1">
          <div class="tit">著作展示</div>
          <div class="titli" @click="goroute(1)">医学影像数字化技术（Ⅰ）</div>
          <div class="titli" @click="goroute(2)">医院信息化技术（Ⅱ）</div>
          <div class="titli" @click="goroute(3)">医院信息化技术（Ⅲ）</div>
          <div class="titli" @click="goroute(4)">医院信息化技术（Ⅳ）</div>
        </div>
        <div class="flex1">
          <div class="tit">关于我们</div>
          <div class="titli" @click="titlego(1)">公司介绍</div>
          <div class="titli" @click="titlego(2)">企业资质</div>
          <div class="titli" @click="titlego(3)">技术支持</div>
        </div>
      </div>
      <div class="flex2">
        <div class="tit">北京洛克斯科技发展有限公司</div>
        <div class="titli">
          <p>
            地址：中国·北京·中关村医学工程转化中心1号楼四层<br />电话：010-
            81787502邮箱：locus@chinalocus.com <br />邮编：100094
          </p>
        </div>
        <div class="titli">
          <el-tooltip placement="top" effect="light">
            <div slot="content">
              <img src="./assets/wx.jpg" alt />
            </div>
            <img class="imwx" src="./assets/300.jpg" alt />
          </el-tooltip>
        </div>
        <div class="titli toplis" @click="goicp">
          Copyright©2019 北京洛克斯科技发展有限公司&nbsp;
          <span class="icp">京ICP备08008930号-1</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "App",
  components: {},
  data() {
    return {
      activeIndex: "1",
      flag: true,
      visb: false,
    };
  },
  watch: {
    $route() {
      if (this.$route.path == "/") {
        this.activeIndex = "1";
        this.flag = true;
      } else if (this.$route.path == "/about") {
        this.activeIndex = "1";
        this.flag = true;
      } else if (this.$route.path == "/booklist") {
        this.activeIndex = "2-1";
        this.flag = true;
      } else if (this.$route.path == "/locustitle") {
        this.activeIndex = "5-1";
        this.flag = true;
      } else if (this.$route.path == "/locusanli") {
        this.activeIndex = "6-1";
        this.flag = true;
      } else if (
        this.$route.path == "/newmeet" ||
        this.$route.path == "/newdetil"
      ) {
        this.activeIndex = "4";
        this.flag = true;
      } else if (
        this.$route.path == "/chanpin" ||
        this.$route.path == "/chanpindetil"
      ) {
        this.activeIndex = "3";
        this.flag = true;
      } else if (this.$route.path == "/loginindex") {
        this.flag = false;
      }
    },
  },
  created() {
    console.log(this.$route.path);
    if (this.$route.path == "/") {
      this.activeIndex = "1";
      this.flag = true;
    } else if (this.$route.path == "/about") {
      this.activeIndex = "1";
      this.flag = true;
    } else if (this.$route.path == "/booklist") {
      this.activeIndex = "2-1";
      this.flag = true;
    } else if (this.$route.path == "/locustitle") {
      this.activeIndex = "5-1";
      this.flag = true;
    } else if (this.$route.path == "/locusanli") {
      this.activeIndex = "6-1";
      this.flag = true;
    } else if (
      this.$route.path == "/newmeet" ||
      this.$route.path == "/newdetil"
    ) {
      this.activeIndex = "4";
      this.flag = true;
    } else if (
      this.$route.path == "/chanpin" ||
      this.$route.path == "/chanpindetil"
    ) {
      this.activeIndex = "3";
      this.flag = true;
    } else if (this.$route.path == "/loginindex") {
      this.flag = false;
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      this.activeIndex = key;
    },
    goroute(a) {
      this.$router.push({
        name: "booklist",
        query: {
          id: a,
        },
      });
    },
    titlego(a) {
      this.$router.push({
        name: "locustitle",
        query: {
          id: a,
        },
      });
    },
    anligo(a) {
      this.$router.push({
        name: "locusanli",
        query: {
          id: a,
        },
      });
    },
    goicp() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index");
    },
  },
};
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-top: 60px;
  background-color: #fcfcfc;
}
.pt {
  padding-top: 0px !important;
}
* {
  padding: 0;
  margin: 0;
}
.topmeun {
  width: 100%;
  height: 60px;
  // line-height: 60px;
  background-color: #f5f5f5;
  position: fixed;
  top: 0;
  z-index: 9999999999;
}
.topme {
  width: 100%;
  // height: 60px;
  // line-height: 60px;
  background-color: #f5f5f5;
  position: fixed;
  top: 0;
  z-index: 9999999999;
}
.topm {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 15px;
  font-size: 20px;
  font-weight: 700;
  color: #000;
}
.topf {
  width: 100%;
  background-color: #fff;
  padding: 10px;
  box-sizing: border-box;
}
.meun {
  width: 66%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  // align-items: center;
}
.meun_left {
  flex: 120px;
  text-align: left;
  box-sizing: border-box;
  padding: 5px 0;
  img {
    width: 160px;
    height: 50px;
    // margin-top: 5px;
  }
}
.shoume {
  width: 100%;
  height: 400px;
  text-align: left;
  overflow-y: auto;
}
.el-menu-demo {
  overflow-y: auto;
}
.meun_right {
  // flex: 1;
  height: 100%;
  line-height: 60px;
  text-align: right;
  .el-menu {
    background-color: #f5f5f5;
    height: 60px;
    line-height: none;
    /deep/.el-menu-item {
      height: 60px;
      line-height: none;
    }
    /deep/.is-active {
      background-color: #f5f5f5;
    }
  }
}
// nav {
//   padding: 30px;

//   a {
//     font-weight: bold;
//     color: #2c3e50;

//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }
.flootli {
  width: 100%;
  min-height: 280px;
  padding-bottom: 15px;
  background-color: #1c1c1c;
  .flootmon {
    width: 63%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding: 30px 0;
    .flex1 {
      flex: 0.2;
      color: #fff;
      text-align: center;
      .tit {
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 20px;
      }
      .titli {
        font-size: 14px;
        color: #8a8a8a;
        margin-bottom: 10px;
      }
    }
    .flex2 {
      flex: 0.45;
      .tit {
        font-size: 26px;
        font-weight: 500;
        color: #fff;
        margin-bottom: 20px;
      }
    }
  }
  .titli {
    font-size: 14px;
    color: #8a8a8a;
    // margin-bottom: 10px;
    .imwx {
      width: 30px;
      height: 30px;
      cursor: pointer;
    }
  }
  .toplis {
    margin-top: 20px;
    text-align: center;
    .icp {
      cursor: pointer;
    }
  }
}
.flootlis {
  width: 100%;
  background-color: #1c1c1c;
  .flootmon {
    width: 100%;
    display: flex;
    text-align: center;
    box-sizing: border-box;
    padding: 10px;
    font-size: 14px;
    .flex1 {
      flex: 1;
      .tit {
        color: #fff;
        font-size: 16px;
      }
      .titli {
        color: #8a8a8a;
        margin: 10px 0;
      }
    }
  }
  .flex2 {
    text-align: center;
    .tit {
      font-size: 25px;
      color: #fff;
    }
    .titli {
      color: #8a8a8a;
      margin: 10px 0;
      font-size: 14px;
      box-sizing: border-box;
      padding: 10px;
      .content {
        width: 80px;
        height: 80px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .imwx {
        width: 30px;
        height: 30px;
      }
    }
  }
}
</style>
